import axios from 'axios'

const AUTH_SUCCESS = 'AUTH_SUCCESS'
const LOGOUT = 'LOGOUT'
const ERROR_MSG = 'ERROR_MSG'
const LOAD_DATA = 'LOAD_DATA'

const initState ={
	redirectTo:'',
	msg:'',
	user:'',
	type:'',
	
	number:'10',

	goTo:''
}
export function user(state=initState,action) {
	switch (action.type) {
		case 'AUTH_SUCCESS':
			return {...state,isAuth:true}
	
		case 'LOGOUT_SUCCESS':
			return {...state}
		case 'ADD_NUM':

			return {...state,number:Number(state.number)+1,goTo:'1',...action.payLoad}
			default:

			return state

	}
	
}

export function addFun (){
	//console.log(store.getState())
	return {type:'ADD_NUM'}
}

function loginSuccess(data){
  	
  	return {type:'AUTH_SUCCESS',payLoad:data}

}


export function loginVipSuccess(data){
  	
  	return {type:'AUTH_SUCCESS',payLoad:data}

}



export  function getUser ({user,pwd}){

	return dispatch=>{
		axios.post('/user/login',{user,pwd})
			.then(res=>{
				if (res.status==200&&res.data.code===0) {
					
					dispatch(loginSuccess(res))
				}else{
					
				}

			})

	}
}

export function getVipUser (){

	return dispatch=>{
		axios.post('/fapi/gate/checkLogin')
			.then(res=>{
				if (res.status==200&&res.data.code===0) {
					
					dispatch(loginVipSuccess(res))
				}else{
					
				}

			})

	}
}




// WEBPACK FOOTER //
// ./src/redux/user.redux.js